
























import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';
import MembershipList from '@subscriptions/components/lists/admin/membership-list.vue';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';

@Component({
  name: 'bpc-memberships',
  components: {
    'bpc-membership-list': MembershipList,
    'bpc-content-wrapper': ContentWrapper,
  },
})
export default class Membership extends Vue {
  // PROPS
  // DATA
  // LIFECYCLE
  // created(){}
  // mounted(){}
  // updated(){}
  // destroyed(){}
  // COMPUTED
  get actionsPortalTarget() {
    return `memberships-actions-${uuidv4()}`;
  }
  // METHODS
  // WATCHERS
}
